import { combineReducers } from "redux";
import { IAppState } from "./packages/Redux/reduxState";
import { WebChatReducer as AppState } from "./packages/Redux/reducers/AppReducer";


export const reducers = AppState
